import { render, staticRenderFns } from "./UserUsage1Survey.vue?vue&type=template&id=2bccedb0&scoped=true"
import script from "./UserUsage1Survey.vue?vue&type=script&lang=ts"
export * from "./UserUsage1Survey.vue?vue&type=script&lang=ts"
import style0 from "./UserUsage1Survey.vue?vue&type=style&index=0&id=2bccedb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bccedb0",
  null
  
)

export default component.exports